// extracted by mini-css-extract-plugin
export default {"profile":"ProfileBox_profile__sUBZx","container":"ProfileBox_container__z2A3o","nameBox":"ProfileBox_nameBox__wG05i"};